const InfinityEnums = {
  // Coarse occupancy the connector actually reports after the status-model
  // inversion. `Occupied` folds in what used to be Preparing/Charging/
  // SuspendedEV/SuspendedEVSE/Finishing at the connector level; the fine energy
  // state now lives on the connector's active session (see ChargingSessionChargingState
  // / a session's detailedStatus). The legacy fine values are kept only so old
  // records and mappers still read back.
  ConnectorStatus: {
    AVAILABLE: 'Available',
    PREPARING: 'Preparing',
    CHARGING: 'Charging',
    SUSPENDEDEV: 'SuspendedEV',
    SUSPENDEDEVSE: 'SuspendedEVSE',
    FINISHING: 'Finishing',
    OCCUPIED: 'Occupied',
    RESERVED: 'Reserved',
    UNAVAILABLE: 'Unavailable',
    FAULTED: 'Faulted',
    OFFLINE: 'Offline',
  },
  // The fine energy state carried on a charging session (session.chargingState /
  // session.detailedStatus). detailedStatus additionally carries Faulted.
  ChargingSessionChargingState: {
    CHARGING: 'Charging',
    SUSPENDEDEV: 'SuspendedEV',
    SUSPENDEDEVSE: 'SuspendedEVSE',
    EVCONNECTED: 'EVConnected',
  },
  OldConnectorType: {
    CHADEMO: 'CHADEMO',
    TYPE_1: 'TYPE_1',
    TYPE_2: 'TYPE_2',
    COMBO_CCS: 'COMBO_CCS',
    SCHUKO: 'SCHUKO',
    TYPE_1_CCS: 'TYPE_1_CCS',
    GBT_AC: 'GB/T AC',
    GBT_DC: 'GB/T DC',
    NACS: 'NACS',
  },
  PowerType: {
    AC_1_PHASE: 'AC_1_PHASE',
    AC_2_PHASE: 'AC_2_PHASE',
    AC_3_PHASE: 'AC_3_PHASE',
    AC_2_PHASE_SPLIT: 'AC_2_PHASE_SPLIT',
    DC: 'DC',
  },
  ConnectorType: {
    CHADEMO: 'CHADEMO',
    CHAOJI: 'CHAOJI',
    DOMESTIC_A: 'DOMESTIC_A',
    DOMESTIC_B: 'DOMESTIC_B',
    DOMESTIC_C: 'DOMESTIC_C',
    DOMESTIC_D: 'DOMESTIC_D',
    DOMESTIC_E: 'DOMESTIC_E',
    DOMESTIC_F: 'DOMESTIC_F',
    DOMESTIC_G: 'DOMESTIC_G',
    DOMESTIC_H: 'DOMESTIC_H',
    DOMESTIC_I: 'DOMESTIC_I',
    DOMESTIC_J: 'DOMESTIC_J',
    DOMESTIC_K: 'DOMESTIC_K',
    DOMESTIC_L: 'DOMESTIC_L',
    DOMESTIC_M: 'DOMESTIC_M',
    DOMESTIC_N: 'DOMESTIC_N',
    DOMESTIC_O: 'DOMESTIC_O',
    GBT_AC: 'GBT_AC',
    GBT_DC: 'GBT_DC',
    IEC_60309_2_SINGLE_16: 'IEC_60309_2_single_16',
    IEC_60309_2_THREE_16: 'IEC_60309_2_three_16',
    IEC_60309_2_THREE_32: 'IEC_60309_2_three_32',
    IEC_60309_2_THREE_64: 'IEC_60309_2_three_64',
    IEC_62196_T1: 'IEC_62196_T1',
    IEC_62196_T1_COMBO: 'IEC_62196_T1_COMBO',
    IEC_62196_T2: 'IEC_62196_T2',
    IEC_62196_T2_COMBO: 'IEC_62196_T2_COMBO',
    IEC_62196_T3A: 'IEC_62196_T3A',
    IEC_62196_T3C: 'IEC_62196_T3C',
    NEMA_5_20: 'NEMA_5_20',
    NEMA_6_30: 'NEMA_6_30',
    NEMA_6_50: 'NEMA_6_50',
    NEMA_10_30: 'NEMA_10_30',
    NEMA_10_50: 'NEMA_10_50',
    NEMA_14_30: 'NEMA_14_30',
    NEMA_14_50: 'NEMA_14_50',
    PANTOGRAPH_BOTTOM_UP: 'PANTOGRAPH_BOTTOM_UP',
    PANTOGRAPH_TOP_DOWN: 'PANTOGRAPH_TOP_DOWN',
    TESLA_R: 'TESLA_R',
    TESLA_S: 'TESLA_S',
  },
  OperatorUserPermission: {
    CAN_VIEW_CHARGING_TOKEN: 1,
    CAN_EDIT_CHARGING_TOKEN: 2,

    CAN_VIEW_CHARGING: 3,
    CAN_EDIT_CHARGING: 4,

    CAN_VIEW_STATION_CHARGEPOINT: 5,
    CAN_EDIT_CHARGEPOINT: 6,
    CAN_DELETE_CHARGEPOINT: 7,
    CAN_EDIT_STATION: 8,

    CAN_VIEW_OPERATOR_USER: 9,
    CAN_EDIT_OPERATOR_USER: 10,

    CAN_VIEW_ACCESS_GROUPS: 11,
    CAN_EDIT_ACCESS_GROUPS: 12,

    CAN_VIEW_TARIFF: 13,
    CAN_EDIT_TARIFF: 14,

    CAN_VIEW_CHARGEPOINT_PRIVACY_RULE: 15,
    CAN_EDIT_CHARGEPOINT_PRIVACY_RULE: 16,

    CAN_EDIT_RULE: 17,

    CAN_EDIT_OPERATOR: 18,

    CAN_ADD_STATION: 19,
    CAN_ADD_CHARGEPOINT: 20,

    CAN_START_TX: 21,
    CAN_STOP_TX: 22,
    CAN_RESERVE_CONNECTOR: 23,
    CAN_CANCEL_RESERVATION: 24,
    CAN_UNLOCK_CONNECTOR: 25,

    CAN_VIEW_CONFIGURATION: 26,
    CAN_EDIT_CONFIGURATION: 27,
    CAN_VIEW_DIAGNOSTICS: 28,
    CAN_REQUEST_DIAGNOSTICS: 29,
    CAN_VIEW_FIRMWARE: 30,
    CAN_UPLOAD_FIRMWARE: 31,
    CAN_USE_TERMINAL: 32,
    CAN_HARD_RESET_CHARGEPOINT: 33,
    CAN_SOFT_RESET_CHARGEPOINT: 34,
    CAN_CLEAR_CACHE: 35,
    CAN_TRIGGER_MESSAGE: 36,

    CAN_DOWNLOAD_TRANSACTIONS: 37,
    CAN_DOWNLOAD_STATION_LOGS: 38,

    CAN_VIEW_CHARGEPOINT_UPTIME: 39,
    CAN_VIEW_CONNECTOR_UTILIZATION: 40,

    CAN_VIEW_LOCAL_LIST: 41,
    CAN_EDIT_LOCAL_LIST: 42,

    CAN_VIEW_ALERT: 43,
    CAN_EDIT_ALERT: 44,

    CAN_VIEW_CHARGING_PROFILE: 45,
    CAN_EDIT_CHARGING_PROFILE: 46,

    CAN_VIEW_COMPOSITE_SCHEDULE: 47,

    CAN_VIEW_CHARGEPOINT_CHARGING_PROFILE: 48,
    CAN_EDIT_CHARGEPOINT_CHARGING_PROFILE: 49,

    CAN_VIEW_OPERATOR_USER_ACTIONS_CHARGE_POINT: 50,
    CAN_VIEW_OPERATOR_USER_ACTIONS_CHARGE_TOKEN: 51,

    CAN_INITIATE_OCPI_CONNECTION: 52,
    CAN_VIEW_OCPI_INTEGRATION: 53,
    CAN_EDIT_OCPI_INTEGRATION: 54,

    CAN_VIEW_ANALYTICS_DATA: 55,

    CAN_EDIT_TRANSACTION: 56,
  },
  InvitationStatus: {
    ACCEPTED: 'Accepted',
    PENDING: 'Pending',
  },
  ResetType: {
    HARD: 'Hard',
    SOFT: 'Soft',
  },

  ChargingTokenStatus: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DEACTIVATED: 'Deactivated',
  },
  ChargingTokenType: {
    RFID: 'Rfid',
    VIRTUAL: 'Virtual',
  },
  ChargingSessionStatus: {
    STARTING: 'Starting',
    STARTED: 'Started',
    UPDATED: 'Updated',
    ENDING: 'Ending',
    ENDED: 'Ended',
  },
  ChargingSpeedLevels: {
    LEVEL1: 'level 1',
    LEVEL2: 'level 2',
    LEVEL3: 'level 3',
  },
  ConfigurationStatus: {
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    REBOOT_REQUIRED: 'RebootRequired',
    NOT_SUPPORTED: 'NotSupported',
  },
  UploadDiagnosticsStatus: {
    IDLE: 'Idle',
    UPLOADING: 'Uploading',
    UPLOADED: 'Uploaded',
    UPLOAD_FAILED: 'UploadFailed',
  },
  MessageTrigger: {
    BOOT_NOTIFICATION: 'BootNotification',
    DIAGNOSTICS_STATUS_NOTIFICATION: 'DiagnosticsStatusNotification',
    FIRMWARE_STATUS_NOTIFICATION: 'FirmwareStatusNotification',
    HEARTBEAT: 'Heartbeat',
    METER_VALUES: 'MeterValues',
    STATUS_NOTIFICATION: 'StatusNotification',
  },
  OCPPActions: {
    // Outgoing
    CANCEL_RESERVATION: 'CancelReservation',
    CHANGE_AVAILABILITY: 'ChangeAvailability',
    CHANGE_CONFIGURATION: 'ChangeConfiguration',
    CLEAR_CACHE: 'ClearCache',
    CLEAR_CHARGING_PROFILE: 'ClearChargingProfile',
    DATA_TRANSFER: 'DataTransfer',
    GET_COMPOSITE_SCHEDULE: 'GetCompositeSchedule',
    GET_CONFIGURATION: 'GetConfiguration',
    GET_DIAGNOSTICS: 'GetDiagnostics',
    GET_LOCAL_LIST_VERSION: 'GetLocalListVersion',
    REMOTE_START_TRANSACTION: 'RemoteStartTransaction',
    REMOTE_STOP_TRANSACTION: 'RemoteStopTransaction',
    RESERVE_NOW: 'ReserveNow',
    RESET: 'Reset',
    SEND_LOCAL_LIST: 'SendLocalList',
    SET_CHARGING_PROFILE: 'SetChargingProfile',
    TRIGGER_MESSAGE: 'TriggerMessage',
    UNLOCK_CONNECTOR: 'UnlockConnector',
    UPDATE_FIRMWARE: 'UpdateFirmware',

    //Incoming
    BOOT_NOTIFICATION: 'BootNotification',
    AUTHORIZE: 'Authorize',
    DIAGNOSTICS_STATUS_NOTIFICATION: 'DiagnosticsStatusNotification',
    FIRMWARE_STATUS_NOTIFICATION: 'FirmwareStatusNotification',
    HEARTBEAT: 'Heartbeat',
    METER_VALUES: 'MeterValues',
    START_TRANSACTION: 'StartTransaction',
    STATUS_NOTIFICATION: 'StatusNotification',
    STOP_TRANSACTION: 'StopTransaction',
  },
  ChargePointSpecsContainer: {
    CHARGEPOINT: 0,
    MODAL: 2,
    CHARGINGTOKENS: 3,
  },
  ConnectorPowerLevel: {
    LEVEL1: 22,
    LEVEL2: 100,
  },
  TransactionStatus: {
    REVERSED: 'Reversed',
    CORRECTED: 'Corrected',
    NORMAL: 'Normal',
    VOID: 'Void',
  },
  ChargePointUptimeStatus: {
    ONLINE: 'Online',
    OFFLINE: 'Offline',
    UNSTABLE: 'Unstable',
  },
  CurrentType: {
    AC: 'AC',
    DC: 'DC',
  },
  OperatorUserActionType: {
    Create: 'Create',
    Edit: 'Edit',
    Delete: 'Delete',
    OCPP: 'OCPP',
    Activate: 'Activate',
    Deactivate: 'Deactivate',
    Move: 'Move',
    Invite: 'Invite',
  },
  OperatorUserOcppActionType: {
    RemoteStartTransaction: 'RemoteStartTransaction',
    RemoteStopTransaction: 'RemoteStopTransaction',
    Reserve: 'Reserve',
    CancelReservation: 'CancelReservation',
    ChangeConfiguration: 'ChangeConfiguration',
    Reset: 'Reset',
    ChangeAvailability: 'ChangeAvailability',
    UnlockConnector: 'UnlockConnector',
    UploadDiagnostics: 'UploadDiagnostics',
    ClearCache: 'ClearCache',
    UpdateFirmware: 'UpdateFirmware',
    TriggerMessage: 'TriggerMessage',
    OcppRequest: 'OcppRequest',
    ClearChargingProfile: 'ClearChargingProfile',
    SetChargingProfile: 'SetChargingProfile',
    SendLocalList: 'SendLocalList',
  },

  Models: {
    AccessGroup: 'AccessGroup',
    ChargePoint: 'ChargePoint',
    ChargingProfile: 'ChargingProfile',
    ChargingSession: 'ChargingSession',
    ChargePointDiagnostics: 'ChargePointDiagnostics',
    ChargingToken: 'ChargingToken',
    City: 'City',
    InviteOperatorUser: 'InviteOperatorUser',
    LocalList: 'LocalList',
    PrivacyRule: 'PrivacyRule',
    Reservation: 'Reservation',
    Station: 'Station',
    Tariff: 'Tariff',
    Operator: 'Operator',
    OperatorAlert: 'OperatorAlert',
    OperatorUser: 'OperatorUser',
    AppChargingToken: 'AppChargingToken',
    AppChargingTokenDesign: 'AppChargingTokenDesign',
  },

  CdrDimensionType: {
    CURRENT: 'CURRENT',
    ENERGY: 'ENERGY',
    ENERGY_EXPORT: 'ENERGY_EXPORT',
    ENERGY_IMPORT: 'ENERGY_IMPORT',
    MAX_CURRENT: 'MAX_CURRENT',
    MIN_CURRENT: 'MIN_CURRENT',
    MAX_POWER: 'MAX_POWER',
    MIN_POWER: 'MIN_POWER',
    PARKING_TIME: 'PARKING_TIME',
    POWER: 'POWER',
    RESERVATION_TIME: 'RESERVATION_TIME',
    STATE_OF_CHARGE: 'STATE_OF_CHARGE',
    TIME: 'TIME',
  },
  Analytics: {
    AVAILABLE: 'Available',
    CHARGING: 'Charging',
    UNAVAILABLE: 'Unavailable',
    FAULTED: 'Faulted',
    OFFLINE: 'Offline',
    OCCUPIED: 'Occupied',
  },
  AlertType: {
    Email: 'Email',
  },
  OperatorAlertStatus: {
    OFFLINE: 'Offline',
    UNSTABLE: 'Unstable',
    FAULTED: 'Faulted',
  },
  AnalyticsFilter: {
    lastYear: 'lastYear',
    thisYear: 'thisYear',
    last6Months: 'last6Months',
    last3Months: 'last3Months',
    lastMonth: 'lastMonth',
    thisMonth: 'thisMonth',
  },
  TokensActivityDurations: {
    lastYear: 'lastYear',
    thisYear: 'thisYear',
    last6Months: 'last6Months',
    last3Months: 'last3Months',
    lastMonth: 'lastMonth',
    lastWeek: 'lastWeek',
  },
  DayOfWeek: {
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY',
  },
  ReservationRestrictionType: {
    RESERVATION: 'RESERVATION',
    RESERVATION_EXPIRED: 'RESERVATION_EXPIRED',
  },
  TariffType: {
    AD_HOC_PAYMENT: 'AD_HOC_PAYMENT',
    PROFILE_CHEAP: 'PROFILE_CHEAP',
    PROFILE_FAST: 'PROFILE_FAST',
    PROFILE_GREEN: 'PROFILE_GREEN',
    REGULAR: 'REGULAR',
  },
  TariffDimensionType: {
    TIME: 'TIME',
    ENERGY: 'ENERGY',
    FLAT: 'FLAT',
    PARKING_TIME: 'PARKING_TIME',
  },
}

export default InfinityEnums
